// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiErrorAPIModel,
    ApiErrorAPIModelFromJSON,
    ApiErrorAPIModelToJSON,
    SbpInvoiceSummaryAPIModel,
    SbpInvoiceSummaryAPIModelFromJSON,
    SbpInvoiceSummaryAPIModelToJSON,
} from '../models';

/**
 * InvoiceApi - interface
 * 
 * @export
 * @interface InvoiceApiInterface
 */
export interface InvoiceApiInterface {
    /**
     * [Demo] Force cancels SBP invoice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApiInterface
     */
    cancelSbpInvoiceRaw(): Promise<runtime.ApiResponse<void>>;

    /**
     * [Demo] Force cancels SBP invoice
     */
    cancelSbpInvoice(): Promise<void>;

    /**
     * Creates new SBP invoice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApiInterface
     */
    createSbpInvoiceRaw(): Promise<runtime.ApiResponse<SbpInvoiceSummaryAPIModel>>;

    /**
     * Creates new SBP invoice
     */
    createSbpInvoice(): Promise<SbpInvoiceSummaryAPIModel>;

    /**
     * Returns current/active SBP invoice details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApiInterface
     */
    getSbpInvoiceRaw(): Promise<runtime.ApiResponse<SbpInvoiceSummaryAPIModel>>;

    /**
     * Returns current/active SBP invoice details
     */
    getSbpInvoice(): Promise<SbpInvoiceSummaryAPIModel>;

}

/**
 * 
 */
export class InvoiceApi extends runtime.BaseAPI implements InvoiceApiInterface {

    /**
     * [Demo] Force cancels SBP invoice
     */
    async cancelSbpInvoiceRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("httpAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoices/sbp/cancel-current`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * [Demo] Force cancels SBP invoice
     */
    async cancelSbpInvoice(): Promise<void> {
        await this.cancelSbpInvoiceRaw();
    }

    /**
     * Creates new SBP invoice
     */
    async createSbpInvoiceRaw(): Promise<runtime.ApiResponse<SbpInvoiceSummaryAPIModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("httpAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoices/sbp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SbpInvoiceSummaryAPIModelFromJSON(jsonValue));
    }

    /**
     * Creates new SBP invoice
     */
    async createSbpInvoice(): Promise<SbpInvoiceSummaryAPIModel> {
        const response = await this.createSbpInvoiceRaw();
        return await response.value();
    }

    /**
     * Returns current/active SBP invoice details
     */
    async getSbpInvoiceRaw(): Promise<runtime.ApiResponse<SbpInvoiceSummaryAPIModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("httpAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/invoices/sbp/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SbpInvoiceSummaryAPIModelFromJSON(jsonValue));
    }

    /**
     * Returns current/active SBP invoice details
     */
    async getSbpInvoice(): Promise<SbpInvoiceSummaryAPIModel> {
        const response = await this.getSbpInvoiceRaw();
        return await response.value();
    }

}
